import { render, staticRenderFns } from "./general-work-fix.vue?vue&type=template&id=55ffac12&scoped=true"
import script from "./general-work-fix.vue?vue&type=script&lang=js"
export * from "./general-work-fix.vue?vue&type=script&lang=js"
import style0 from "./general-work-fix.vue?vue&type=style&index=0&id=55ffac12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ffac12",
  null
  
)

export default component.exports